export function sortTradesByName(trades) {
    return trades.sort((trade1, trade2) => {
        return trade1.name.toUpperCase().localeCompare(trade2.name.toUpperCase());
    });
}
//# sourceMappingURL=sort_trades_by_name.js.map